import { useState, useEffect } from 'react'
import { useAuth } from './AuthProvider'
import SignInForm from './SignInForm'
import EmailVerificationStep from './EmailVerificationStep'
import { isFullyVerified, type User } from '../../lib/auth'

type Step = 'SIGN_IN' | 'EMAIL_VERIFY' | 'READY'

interface CreatorAuthGateProps {
  onReady: () => void
}

function determineStep(user: User | null): Step {
  if (!user) return 'SIGN_IN'
  return isFullyVerified(user) ? 'READY' : 'EMAIL_VERIFY'
}

export default function CreatorAuthGate({ onReady }: CreatorAuthGateProps) {
  const { user } = useAuth()
  const [step, setStep] = useState<Step>(() => determineStep(user))

  useEffect(() => {
    const computed = determineStep(user)
    if (computed === 'READY') {
      onReady()
    }
    setStep(computed)
  }, [user, onReady])

  if (step === 'SIGN_IN') {
    return (
      <div className="space-y-4">
        <p className="text-sm text-navy/75 leading-relaxed">
          Day One is free, and every session runs on your account. Sign in with Google
          or an email you can verify, so the session saves to My Sessions and your
          results reach your inbox when you finish.
        </p>
        <SignInForm
          onSignedIn={(u) => {
            setStep(determineStep(u))
          }}
        />
      </div>
    )
  }

  if (step === 'EMAIL_VERIFY') {
    return <EmailVerificationStep onVerified={onReady} />
  }

  return null
}
